'use strict';

/**
 * Global project configuration
 **/
export const GlobalConfig = Object.freeze({
    // DebugMode project
    _debugMode: true,
    // If the project is oneClient or multiClient. Use [url_client. ej. rebus] o false
    _isOneClient: 'centro_eventos',
    // Default Language
    _defaultLang: 'es',
    // Domain
    _domain: 'http://localhost:9422',
    // Time Zone
    _timezone: 'America/Bogota',
    _timezoneHour: '-05:00',
    // Delay time execution of connect data. Use [Integer]
    _timeoutConnect: 20000,
    _eventDefaultBlocked: {
      "configMenu": {
        "isMenu": true,
        "menuCinco": "networking",
        "menuCuatro": "map",
        "menuDos": "social",
        "menuSeis": "profile",
        "menuTres": "speaker",
        "menuUno": "diary"
      },
      "configSponsor": {
        "autoplay": "3000",
        "direction": "horizontal",
        "loop": true,
        "pager": true,
        "speed": "2000"
      },
      "defaultLanguage": "es",
      "id": "centro_eventos",
      "languages": ["es"],
      "modules": {
        "activity": true,
        "catalog": true,
        "diary": true,
        "embed": true,
        "map": true,
        "message": true,
        "networking": true,
        "now": true,
        "opinometer": true,
        "question": true,
        "social": true,
        "speaker": true,
        "sponsor": true,
        "stands": true,
        "streaming": true
      },
      "name": "Valle del Pacífico Centro de Eventos",
      "nit": "NA",
      "permissions": {
        "defaultPage": "EventPage",
        "forgot": true,
        "loginAlternative": "Email",
        "loginBlocked": true,
        "loginRequired": false,
        "loginSocial": {
          "facebook": true,
          "google": true,
          "twitter": true
        },
        "register": true
      },
      "secretCode": "centro_eventos",
      "state": true,
      "styles": {
        "buttonDos": "centro_eventos_button_dos",
        "buttonUno": "centro_eventos_button_uno",
        "colorCuatro": "#ffffff",
        "colorDos": "#7BBBE8",
        "colorTres": "#7BBBE8",
        "colorUno": "#0057b8",
        "folder": "centro_eventos",
        "footer": "centro_eventos_footer",
        "header": "centro_eventos_header"
      },
      "url": "centro_eventos"
    }
});
// end file



// WEBPACK FOOTER //
// ./src/app/app.config.ts